export type AppConfig = {
  temporaryLaunchGate: {
    enabled: boolean;
    password: string;
    storageKey: string;
  };
  mapbox: {
    accessToken: string;
    defaultStyleUri: string;
  };
  purchases: {
    publicApiKey: string;
  };
  liveRacers: {
    pollIntervalMs: number;
  };
};

const parsePositiveInt = (value: string | undefined, fallback: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const parseBooleanFlag = (value: string | undefined, fallback: boolean) => {
  if (value === undefined) {
    return fallback;
  }

  return ["1", "true", "yes", "on"].includes(value.trim().toLowerCase());
};

export const appConfig: AppConfig = {
  temporaryLaunchGate: {
    enabled: parseBooleanFlag(
      process.env.REACT_APP_ENABLE_TEMPORARY_LAUNCH_GATE,
      false
    ),
    password: process.env.REACT_APP_TEMPORARY_LAUNCH_PASSWORD || "loputocrack",
    storageKey: "rauxa.maintenanceAccessGranted.v1",
  },
  mapbox: {
    accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || "",
    defaultStyleUri:
      process.env.REACT_APP_MAPBOX_DEFAULT_STYLE_URI ||
      "mapbox://styles/mapbox/outdoors-v12",
  },
  purchases: {
    publicApiKey: process.env.REACT_APP_REVENUECAT_PUBLIC_API_KEY || "",
  },
  liveRacers: {
    pollIntervalMs: parsePositiveInt(
      process.env.REACT_APP_LIVE_RACERS_POLL_MS,
      12000
    ),
  },
};
